import React from 'react';
import { ILuxuryHome } from '@share/common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBath, faBed, faKitchenSet, faUser } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps {
  home: ILuxuryHome;
  layoutRef: React.RefObject<HTMLDivElement>;
}

const LayoutItem = ({ icon, value, display, text }: { icon: any, value: string, display: boolean, text?: string }) => {
  if (!display) {
    return null;
  }

  return (
    <div className="layout-item">
      <span className="layout-value"><FontAwesomeIcon icon={icon} style={{ color: '#1F4D5A', marginRight: 10 }} /> {value} {text && <span className="text">{text}</span>}</span>
    </div>
  );
}

export const LuxuryHomesDetailsLayout: React.FC<IProps> = ({ home, layoutRef }) => {

  const mainUnit = home?.units?.[0];

  return (  
    <section id="layout" className="property-section" ref={layoutRef}>
      <h2>Layout</h2>
      <div className="layout-grid">
        <LayoutItem icon={faBed} value={mainUnit?.bedroomsCount || '0'} text={mainUnit?.bedroomsCount > 1 ? 'Bedrooms' : 'Bedroom'} display />

        <LayoutItem icon={faUser} value={mainUnit?.maxOccupancy || '0'} text={mainUnit?.maxOccupancy > 1 ? 'Occupants' : 'Occupant'} display />

        <LayoutItem icon={faBath} value={mainUnit?.bathroomsCount || '0'} text={mainUnit?.bathroomsCount > 1 ? 'Bathrooms' : 'Bathroom'} display />

        <LayoutItem icon={faBed} value={mainUnit?.bedRoomType || ''} display={!!mainUnit?.bedRoomType} />

        <LayoutItem icon={faKitchenSet} value={mainUnit?.kitchenType || ''} display={!!mainUnit?.kitchenType && mainUnit?.kitchenType !== 'Unknown'} />
      </div>
    </section>
  );
};
